import { makeAutoObservable } from "mobx";
import { enableStaticRendering } from "mobx-react";

const isServer = typeof window === "undefined";
enableStaticRendering(isServer);

class ConfigStore {
  config = {
    applicationFormConfig: {},
  };

  cacheEnabled = true; // Default to true, will be set from server on hydration

  constructor(initialData) {
    makeAutoObservable(this);
    if (initialData) {
      this.config = { ...initialData };
      // Set cacheEnabled from server-side data if provided
      if (initialData.cacheEnabled !== undefined) {
        this.cacheEnabled = initialData.cacheEnabled;
      }
    }
  }

  setCacheEnabled(value) {
    this.cacheEnabled = value;
  }
}

export default ConfigStore;
